<div class="upper-space">
  <div class="d-flex">
    <div class="design-edit-container">
      <div class="d-flex">
        <mat-form-field appearance="outline">
          <mat-select
            matInput
            placeholder="Selecteer medewerker"
            [(ngModel)]="selectedDesigner"
            [compareWith]="compareEntities"
            (ngModelChange)="selectedDesignerChanged()"
          >
            <mat-option *ngFor="let option of designerChoices" [value]="option">
              {{ option.user?.firstName | personName: option.user?.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="left-space">
          <mat-form-field appearance="outline">
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Selecteer een datum"
              [(ngModel)]="selectedDeadline"
              (ngModelChange)="selectedDeadlineChanged()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="less-mat-form-field-bottom-padding">
        <div class="width-75">
          <textarea-input
            [placeholder]="'Interne communicatie over het ontwerp'"
            [initContent]="needsDesignDescription"
            [sensitive]="true"
            [client]="true"
            (answer)="needsDesignDescriptionChanged($event)"
          >
          </textarea-input>
        </div>
        <div class="width-75">
          <textarea-input
            [placeholder]="'Opvolging van dit ontwerp - Interne feedback'"
            [initContent]="emailText"
            [sensitive]="true"
            [client]="true"
            (answer)="emailTextChanged($event)"
          >
          </textarea-input>
        </div>
      </div>

      <div class="d-inline-flex">
        <div
          *ngIf="contactName?.length > 0 && contactEmail?.length > 0"
          class="left-fifteen-space clickable send-mail-button"
        >
          <a
            href="{{
              contactEmail
                | mailSubjectBodyLink
                  : project.id
                  : contactName
                  : baseProject.projectPlacement?.address?.line1
                  : baseProject.projectPlacement?.address?.city
                  : baseProject.projectPlacement?.address?.postalCode
                  : 'Hierbij het ontwerp.'
                  : 'Job'
            }}"
            target="_blank"
            >Ontwerp versturen</a
          >
        </div>

        <button
          *ngIf="ipBoard.boardPart?.sign != null"
          class="btn btn-print mr-2"
          mat-flat-button
          (click)="goToBord(ipBoard.boardPart?.sign?.id)"
        >
          Ga naar voorraadbord
        </button>
      </div>

      <div class="upper-space registered-action-display-container">
        <div>
          <mat-checkbox
            [(ngModel)]="designSentToCustomer"
            (ngModelChange)="designSentToCustomerChanged()"
          >
            <ng-container *ngIf="ipBoard.designSentLog == null">
              <i class="secondary-color">Ontwerp #{{ project.id }} verstuurd</i>
            </ng-container>
            <ng-container *ngIf="ipBoard.designSentLog != null">
              <i>{{
                ipBoard.designSentLog.date | formatDate: '':'dd/MM/yyyy HH:mm'
              }}</i>
            </ng-container>
          </mat-checkbox>
        </div>
        <div
          *ngIf="ipBoard.designSentLog != null"
          class="align-with-registration-checkbox"
        >
          <i>{{
            ipBoard.designSentLog.by?.firstName
              | personName: ipBoard.designSentLog.by?.lastName
          }}</i>
        </div>
        <div
          *ngIf="ipBoard.designSentLog != null"
          class="align-with-registration-checkbox"
        >
          <i class="secondary-color">Ontwerp #{{ project.id }} verstuurd</i>
        </div>
      </div>

      <div class="left-fifteen-space">
        <mat-checkbox
          [(ngModel)]="customerApproves"
          (ngModelChange)="customerApprovesChanged()"
        >
          <i class="strong">Goedgekeurd</i>
        </mat-checkbox>
        <ng-container *ngIf="customerApproves">
          <div
            *ngIf="ipBoard.designApprovalRegistration != null"
            class="left-space registered-action-display-container"
          >
            <div>
              <i>{{
                ipBoard.designApprovalRegistration.date
                  | formatDate: '':'dd/MM/yyyy HH:mm'
              }}</i>
            </div>
            <div>
              <i>{{
                ipBoard.designApprovalRegistration.by?.firstName
                  | personName: ipBoard.designApprovalRegistration.by?.lastName
              }}</i>
            </div>
            <div>
              <i class="secondary-color">Ontwerp #{{ project.id }} akkoord</i>
            </div>
          </div>
          <div class="left-space width-75">
            <textarea-input
              [placeholder]="'Akkoord klant - Persoonsnaam noteren'"
              [initContent]="customerApprovalFeedback"
              [sensitive]="true"
              (answer)="customerApprovalFeedbackChanged($event)"
            >
            </textarea-input>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="extra-design-asset-container">
      <file-picker
        [inputProduct]="ipBoard"
        [formSection]="'extraDesign'"
        [uploadButtonLabel]="'Ontwerp toevoegen'"
        (answer)="designAssetsChanged()"
        (assetDeleted)="designAssetsChanged()"
      ></file-picker>
    </div>
  </div>
</div>
